import React from 'react'
import { Route } from 'react-router-dom'
import PasswordExpired from './PasswordExpired'

import { passwordExpiredRoot } from "../../../constants/routePaths"

const PasswordExpiredRoute = [
  <Route
    key="PasswordExpired"
    exact path={passwordExpiredRoot}
    component={PasswordExpired}
  />,
];

export default PasswordExpiredRoute